import { useEffect, useState } from "react";
import { ListMusic, Square } from "lucide-react";
import { playAll, stopVoice } from "@/lib/ariel";

// "Play all": Ariel reads every note of this gate in order, moving along as she goes.
export default function PlayAllButton({ texts, onIndex, testId = "play-all" }) {
  const [on, setOn] = useState(false);
  useEffect(() => () => stopVoice(), []);
  const toggle = async () => {
    if (on) {
      stopVoice();
      setOn(false);
      return;
    }
    setOn(true);
    await playAll(texts, onIndex);
    setOn(false);
  };
  if (!texts?.length) return null;
  return (
    <button data-testid={testId} onClick={toggle} aria-pressed={on} className={`inline-flex items-center gap-2 rounded-full border px-5 py-2.5 font-tt-mono text-[11px] uppercase tracking-[0.2em] transition-colors ${on ? "bg-[#D9B47A] border-[#D9B47A] text-[#0A0706]" : "border-[#D9B47A]/50 text-[#D9B47A] hover:bg-[#D9B47A] hover:text-[#0A0706]"}`}>
      {on ? <><Square className="w-3.5 h-3.5" /> Stop</> : <><ListMusic className="w-4 h-4" /> Play all of Ariel’s notes</>}
    </button>
  );
}
